var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoDataBar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 102,
    viewBox: "0 0 53 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 14"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1261153848"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Jan"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 25536",
    x: 21.5,
    y: 1,
    width: 10,
    height: 100,
    stroke: "#255056",
    strokeOpacity: 0.4,
    strokeWidth: 2,
    strokeDasharray: "3 2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDataBar);
export default __webpack_public_path__ + "static/media/no-data-bar.66e9e8643b4186ac7732d8ee7e7867f7.svg";
export { ForwardRef as ReactComponent };